import { render } from "./MWNavbar.vue?vue&type=template&id=720f1604"
import script from "./MWNavbar.vue?vue&type=script&lang=js"
export * from "./MWNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__